import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './en';
import { es } from './es';
import { FeatureFlagName } from '../../config/featureFlags';
import FeatureFlagManager from '../../config/featureFlags/FeatureFlagManager';

const defaultLang = 'en';
const localizationEnabled = FeatureFlagManager.get<boolean>(FeatureFlagName.isLocalizationEnabled);

const i18nBuilder = i18n.use(initReactI18next);

if (localizationEnabled) {
  i18nBuilder.use(LanguageDetector);
} else {
  const rawChangeLanguage = i18n.changeLanguage.bind(i18n);
  i18n.changeLanguage = (
    _lng?: Parameters<typeof rawChangeLanguage>[0],
    callback?: Parameters<typeof rawChangeLanguage>[1],
  ): ReturnType<typeof rawChangeLanguage> => rawChangeLanguage(defaultLang, callback);
}

i18nBuilder
  .init({
    compatibilityJSON: 'v3',
    debug: false,
    fallbackLng: defaultLang,
    ...(localizationEnabled
      ? {
        detection: {
          order: ['sessionStorage', 'navigator'],
          caches: ['sessionStorage'],
        },
        supportedLngs: ['en', 'es'],
      }
      : {
        lng: defaultLang, // Hard lock English
        supportedLngs: ['en'],
      }
    ),
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
  });

export default i18n;
